import React from 'react';
import styled from 'styled-components';
import { Body1, Body5, Container } from '@ui';
import { convertHexToRGBA } from '@utils/usefulFuncs';
import { isUndefinedOrNull, logNetRequest } from '@utils/usefulFuncs';
import { handle400Statuses, sendApiRequest } from '@services/api';
import { Loading } from '@ui/Loading';
import { assembleDocumentTypes } from '@utils/doc';

const Wrapper = styled.div``;
const TickerWrapper = styled.div`
  padding: 4px 8px;
  border: 1px solid ${({ theme }) => theme.themeColors.text};
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.14s;
  min-width: 66px;
  text-align: center;

  &:hover {
    background: ${({ theme }) => convertHexToRGBA(theme.themeColors.primaryCtaButton, 0.1)};
    border: 1px solid ${({ theme }) => convertHexToRGBA(theme.themeColors.primaryCtaButton, 1)};

    * {
      color: ${({ theme }) => theme.themeColors.primaryCtaButton};
    }
  }

  &.selected {
    border: 1px solid ${({ theme }) => theme.themeColors.primaryCtaButton};
    background: ${({ theme }) => theme.themeColors.primaryCtaButton};

    * {
      color: ${({ theme }) => theme.themeColors.buttonText};
    }
  }
`;
const TickersButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 8px;
`;

function isDocumentTypeActive(documentType, activeDocumentType) {
  return documentType === activeDocumentType;
}

const DocumentTypeButton = ({ value, activeDocumentType, onClick }) => {
  return (
    <TickerWrapper
      onClick={() => onClick(value)}
      className={isDocumentTypeActive(value, activeDocumentType) ? 'selected' : ''}
    >
      <Body5 bold>{value === 'unknown' || isUndefinedOrNull(value) ? 'Other Materials' : value}</Body5>
    </TickerWrapper>
  );
};

export const DocumentIdsSelection = ({
  selectedDocIds,
  handleAddDocument: onSelect,
  handleRemoveDocument: onRemoveSelect,
  tool,
}) => {
  const [documentTypes, setDocumentTypes] = React.useState([]);
  const [activeDocumentType, setActiveDocumentType] = React.useState(null);
  const [docs, setDocs] = React.useState(null);
  const [filteredDocs, setFilteredDocs] = React.useState([]);

  React.useEffect(() => {
    const fetchDocs = async () => {
      const URL = 'v1/genai/documents/default?user_mode=' + tool;
      const { status, data, error } = await sendApiRequest('get', URL);
      handle400Statuses(status);
      logNetRequest(status, data, error);
      if (status === 200) {
        const docs = data.documents;
        setDocs(docs);
        setDocumentTypes(assembleDocumentTypes(docs));
        setFilteredDocs(docs);
      } else {
        console.error('Error fetching docs', error);
      }
    };
    fetchDocs();
  }, []);

  const handleDocumentTypeClick = (d) => {
    if (d === activeDocumentType) {
      setActiveDocumentType(null);
      setFilteredDocs(docs);
      return;
    }

    setActiveDocumentType(d);
    const filtered = docs.filter((doc) => doc.doc_type === d);
    setFilteredDocs(filtered);
  };

  if (!docs) {
    return (
      <Wrapper>
        <Loading />
      </Wrapper>
    );
  }

  // implement this when use case is needed
  if (docs.length === 0 || true) {
    return (
      <Wrapper>
        <Container centerAll top={72} bottom={96}>
          <Body1>No documents found. Upload a document to get started.</Body1>
        </Container>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Container>
        <Container bottom={12}>
          <Body5>Document Types</Body5>
        </Container>
        <TickersButtonWrapper>
          {documentTypes.map((dt) => (
            <DocumentTypeButton
              key={dt}
              value={dt}
              activeDocumentType={activeDocumentType}
              onClick={handleDocumentTypeClick}
            />
          ))}
        </TickersButtonWrapper>
      </Container>
      <Container top={24}></Container>
    </Wrapper>
  );
};
